import React from 'react';
import { Fill } from 'react-spaces';
import { Outlet } from 'react-router-dom';

const FillLayout: React.FC = ({ children }) => {
  return (
    <Fill as="main" scrollable>
      <div className="layout layout_fill">{children || <Outlet />}</div>
    </Fill>
  );
};

export default FillLayout;
